import EntityManager from '@/pages/admin/components/EntityManager';
import { bookFields, bookColumns } from '@/pages/admin/entityConfigs';

export default function BooksAdminPage() {
  return (
    <EntityManager
      table="books"
      fields={bookFields}
      columns={bookColumns}
      orderBy="sort_order"
      ascending
      searchKeys={['title', 'author']}
      addLabel="Add Book"
    />
  );
}